import { render, staticRenderFns } from "./TermsClient.vue?vue&type=template&id=c6c1cdf0"
import script from "./TermsClient.vue?vue&type=script&lang=js"
export * from "./TermsClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports